export default console; // eslint-disable-line